import { call, fork, put, takeLatest } from "redux-saga/effects";
import * as actions from "../actions/maintenanceActions";
import * as api from "../api/maintenanceApi";

function* fetchMaintenance() {
  try {
    const response = yield call(api.fetchMaintenanceConfig);
    yield put(actions.fetchMaintenanceSuccess(response.data));
  } catch (error) {
    yield put(
      actions.fetchMaintenanceFailure(
        error && error.message
          ? error.message
          : "Greška pri dohvaćanju konfiguracije."
      )
    );
  }
}

function* watchFetchMaintenance() {
  yield takeLatest(actions.Types.FETCH_MAINTENANCE_REQUEST, fetchMaintenance);
}

export default [fork(watchFetchMaintenance)];
